export default __webpack_public_path__ + "static/media/closet3-480w.3b516e4a.webp";